import type { ReviewEntryQuestion } from '../../../types/reviewEntryQuestion'
import { isAlertQuestion } from '../../../utils/reviewEntryQuestionSeverity'

export interface ReviewEntryQuestionCounts {
  alert: number
  question: number
}

interface GetQuestionCountsProps {
  questions: ReviewEntryQuestion[]
}

export const getQuestionCounts = ({ questions }: GetQuestionCountsProps): ReviewEntryQuestionCounts =>
  questions.reduce(
    (counts, question) => {
      if (isAlertQuestion(question)) {
        counts.alert += 1
      } else {
        counts.question += 1
      }

      return counts
    },
    { alert: 0, question: 0 },
  )
